import styled from 'styled-components';
import Colors from '../../constants/Colors';

const FavDetailPane = styled.div`
  display: grid;
  grid-template-rows: 50px 1fr;
  width: auto;
  height: 100%;
  background: ${Colors.deepBlack};
  color: #fff;
`;

export { FavDetailPane };



// WEBPACK FOOTER //
// ./src/components/Favorites/FavDetailUI.tsx